var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1514189554639,
    className: "icon",
    style: {},
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 8871,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 34.4h864v960H80z",
    fill: "#8095FF",
    "p-id": 8872
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M176 112m-40 0a40 40 0 1 0 80 0 40 40 0 1 0-80 0Z",
    fill: "#FFFFFF",
    "p-id": 8873
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M176 272m-40 0a40 40 0 1 0 80 0 40 40 0 1 0-80 0Z",
    fill: "#FFFFFF",
    "p-id": 8874
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M176 432m-40 0a40 40 0 1 0 80 0 40 40 0 1 0-80 0Z",
    fill: "#FFFFFF",
    "p-id": 8875
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M176 592m-40 0a40 40 0 1 0 80 0 40 40 0 1 0-80 0Z",
    fill: "#FFFFFF",
    "p-id": 8876
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M176 752m-40 0a40 40 0 1 0 80 0 40 40 0 1 0-80 0Z",
    fill: "#FFFFFF",
    "p-id": 8877
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M176 912m-40 0a40 40 0 1 0 80 0 40 40 0 1 0-80 0Z",
    fill: "#FFFFFF",
    "p-id": 8878
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M864 112m-40 0a40 40 0 1 0 80 0 40 40 0 1 0-80 0Z",
    fill: "#FFFFFF",
    "p-id": 8879
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M864 272m-40 0a40 40 0 1 0 80 0 40 40 0 1 0-80 0Z",
    fill: "#FFFFFF",
    "p-id": 8880
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M864 432m-40 0a40 40 0 1 0 80 0 40 40 0 1 0-80 0Z",
    fill: "#FFFFFF",
    "p-id": 8881
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M864 592m-40 0a40 40 0 1 0 80 0 40 40 0 1 0-80 0Z",
    fill: "#FFFFFF",
    "p-id": 8882
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M864 752m-40 0a40 40 0 1 0 80 0 40 40 0 1 0-80 0Z",
    fill: "#FFFFFF",
    "p-id": 8883
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M864 912m-40 0a40 40 0 1 0 80 0 40 40 0 1 0-80 0Z",
    fill: "#FFFFFF",
    "p-id": 8884
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M648 508L436 362.4c-4.8-3.2-11.2-4-16.8-0.8-5.6 3.2-8.8 8.8-8.8 14.4v290.4c0 5.6 3.2 11.2 8.8 14.4 5.6 3.2 12 2.4 16.8-0.8L648 533.6c4.8-2.4 7.2-8 7.2-12.8 0-4.8-3.2-9.6-7.2-12.8z",
    fill: "#FFFFFF",
    "p-id": 8885
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.a1b07956cad84a3efc508d024286b30f.svg";
export { ForwardRef as ReactComponent };